export default __webpack_public_path__ + "static/media/icon-save3.d43db0f9.svg";